import L from "leaflet";
import /* webpackPrefetch: true */ "./leaflet.scss";

delete L.Icon.Default.prototype._getIconUrl; // eslint-disable-line

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("./image/pin.png"),
  iconUrl: require("./image/pin.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
  iconSize: [54, 67],
  shadowSize: [0, 0],
  iconAnchor: [27, 67],
  popupAnchor: [0, -67]
});

export default L;
